<div class="tw-relative tw-inline-flex tw-items-center tw-justify-center tw-w-[26px] tw-h-[26px] tw-shrink-0 tw-cursor-pointer tw-select-none tw-touch-manipulation tw-[-webkit-touch-callout:none] tw-[-webkit-user-select:none]"
     (click)="onClick()">
  @if (isListening) {
    <span class="tw-absolute tw-top-1/2 tw-left-1/2 tw-w-[32px] tw-h-[32px] tw-rounded-full tw-bg-teal-200 tw-opacity-60 -tw-translate-x-1/2 -tw-translate-y-1/2 tw-animate-ping tw-z-[1] tw-pointer-events-none"></span>
    <span class="tw-absolute tw-top-1/2 tw-left-1/2 tw-w-[24px] tw-h-[24px] tw-rounded-full tw-bg-teal-200 tw-opacity-90 -tw-translate-x-1/2 -tw-translate-y-1/2 tw-z-[1] tw-pointer-events-none"></span>
  }
  <img class="tw-relative tw-w-[26px] tw-h-[26px] tw-z-[2] tw-pointer-events-none"
       draggable="false"
       [src]="isListening ? 'assets/icons/mic-green.svg' : 'assets/icons/mic-black.svg'"
       alt="Voice input" />
  @if (showTooltip && tooltipReady && !isListening) {
    <div data-testid="voice-mic-tooltip"
         class="tw-absolute tw-bottom-[calc(100%+10px)] tw-right-[calc(50%-29px)] tw-bg-orange-200 tw-text-black tw-text-[14px] tw-leading-[20px] tw-px-3.5 tw-py-[7px] tw-rounded-full tw-whitespace-nowrap tw-pointer-events-none tw-z-[3] tw-animate-anim_scale tw-origin-bottom">
      <span i18n="@@chatVoiceTapToSpeak">Tap to Speak</span>
      <img class="tw-absolute tw-top-full tw-right-[22px] tw-w-[13px] tw-h-[11px] tw-mt-[-1px] -tw-scale-y-100"
           src="assets/icons/tooltip-arrow.svg" alt="" />
    </div>
  }
</div>
